/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const Plus = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 7 7">
      <path d="M6.5,3 L4,3 L4,0.5 C4,0.224 3.776,0 3.5,0 C3.224,0 3,0.224 3,0.5 L3,3 L0.5,3 C0.224,3 0,3.224 0,3.5 C0,3.776 0.224,4 0.5,4 L3,4 L3,6.5 C3,6.776 3.224,7 3.5,7 C3.776,7 4,6.776 4,6.5 L4,4 L6.5,4 C6.776,4 7,3.776 7,3.5 C7,3.224 6.776,3 6.5,3" />
    </BaseSvgIcon>
  )
}

export default Plus
